import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { RiMenu3Line, RiCloseLine, RiArrowDownSLine } from 'react-icons/ri';
import { FaWhatsapp, FaTelegramPlane } from 'react-icons/fa';
import logo from '../../assets/logo.png'
import './navbar.css';

const Menu = () => (
    <>
        <p><a href='/#home'>Home</a></p>
        <p><a href='/#products'>Products</a></p>
        <p><Link to="/file-service">Services</Link></p>
        <p><Link to="/support-list">Support List</Link></p>

        <div className='gpt3__navbar-more'>
            <button type='button' className='gpt3__navbar-more_trigger'>
                <span>More</span>
                <RiArrowDownSLine className='gpt3__navbar-more_icon' aria-hidden='true' />
            </button>
            <div className='gpt3__navbar-more_dropdown'>
                <p><a href='/#wgpt3'>About</a></p>
                <p><a href='/#features'>ECU Solutions</a></p>
            </div>
        </div>
    </>
)

const Navbar = () => {
    const [toggleMenu, setToggleMenu] = useState(false)

    return (
        <div className='gpt3__navbar'>
            <div className='gpt3__navbar-links'>
                <Link to="/" className='gpt3__navbar-links_logo'>
                    <img src={logo} alt="Prinze Tuner Professional ECU Solutions Logo" loading="lazy" />
                    <h1>Prinzetuner</h1>
                </Link>

                <div className='gpt3__navbar-links_container'>
                    <Menu />
                </div>
            </div>

            <div className='gpt3__navbar-contact'>
                <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer" className="contact-btn whatsapp">
                    <FaWhatsapp /> <span>WhatsApp</span>
                </a>
                <a href="https://t.me/Prinzetuner" target="_blank" rel="noreferrer" className="contact-btn telegram">
                    <FaTelegramPlane /> <span>Telegram</span>
                </a>
            </div>

            <div className='gpt3__navbar-menu'>
                {toggleMenu
                    ? <RiCloseLine color="#fff" size="27" onClick={() => setToggleMenu(false)} />
                    : <RiMenu3Line color="#fff" size="27" onClick={() => setToggleMenu(true)} />
                }
                {toggleMenu && (
                    <div className='gpt3__navbar-menu_container scale-up-center'>
                        <div className='gpt3__navbar-menu_container-links'>
                            <Menu />
                            <div className='gpt3__navbar-menu_container-links-contact'>
                                <a href="https://wa.me/966590707424" target="_blank" rel="noreferrer" className="contact-btn whatsapp">
                                    <FaWhatsapp /> <span>WhatsApp</span>
                                </a>
                                <a href="https://t.me/Prinzetuner" target="_blank" rel="noreferrer" className="contact-btn telegram">
                                    <FaTelegramPlane /> <span>Telegram</span>
                                </a>
                            </div>
                        </div>
                    </div>
                )

                }
            </div>

        </div>
    )
}

export default Navbar
